type SubHeaderProps = {
  title: string;
};

const SubHeader = ({ title }: SubHeaderProps) => {
  return (
    <div className="bg-white overflow-hidden h-12 border-b border-b-[#DCDFE4] pl-10 flex items-center">
      <div className="text-blue-950 text-xl font-semibold font-SFProDisplay">
        {title}
      </div>
    </div>
  );
};

export default SubHeader;
